import {APP_INITIALIZER, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EnvironmentLoader, envLoaderFactory} from "./environment-loader.service";
import {Environment} from "./environment";


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    EnvironmentLoader,
    {
      provide: APP_INITIALIZER,
      useFactory: envLoaderFactory,
      deps: [EnvironmentLoader],
      multi: true,
    },
    {provide: Environment, useValue: new Environment()}
  ]
})
export class EnvironmentModule {
}
